import { html } from 'lit';
const Camera =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M10.285 5.75c-.35 0-.67.172-.858.45l-.723 1.066a2.54 2.54 0 0 1-2.1 1.109h-.826c-.579 0-1.028.459-1.028 1v7.875c0 .541.449 1 1.028 1h12.444c.579 0 1.028-.459 1.028-1V9.375c0-.541-.449-1-1.028-1h-.826c-.84 0-1.63-.413-2.1-1.109L14.573 6.2a1.03 1.03 0 0 0-.858-.45zm-2.1-.391a2.54 2.54 0 0 1 2.1-1.109h3.43c.84 0 1.63.413 2.1 1.109l.723 1.066c.188.278.509.45.858.45h.826c1.385 0 2.528 1.108 2.528 2.5v7.875c0 1.392-1.143 2.5-2.528 2.5H5.778c-1.385 0-2.528-1.108-2.528-2.5V9.375c0-1.392 1.143-2.5 2.528-2.5h.826c.349 0 .67-.172.858-.45zM12 11c-1.07 0-1.917.85-1.917 1.875S10.93 14.75 12 14.75s1.917-.85 1.917-1.875S13.07 11 12 11m-3.417 1.875C8.583 11 10.124 9.5 12 9.5s3.417 1.5 3.417 3.375S13.876 16.25 12 16.25s-3.417-1.5-3.417-3.375" clip-rule="evenodd"/>
  </svg>
`;
export default Camera;
